<div
  data-cy="create-warning-details"
  class="details position-absolute start-5 z-3 top-26 max-vh-70 overflow-auto"
  cdkDrag
  cdkDragBoundary="app-root"
  [class.d-none]="!hasFeatureDetails()"
>
  <app-details class="container-fluid p-0" (closed)="close()">
    <div class="p-2">
      <div class="row">
        <app-details-meta-category
          class="col gx-5"
          [category]="featureDetails().get('RoadSegment')"
        >
        </app-details-meta-category>
      </div>

      <div class="row mt-2 gy-2 justify-content-start">
        <div class="section-title col-12 text-start mt-2">Select type:</div>
        <div class="grid-items-container justify-content-start">
          @if (isAccidentsLayerVisible) {
            <ng-container *hasPermissionAny="Layers.VAWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_Accidents) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          }
          @if (isBdvLayerVisible) {
            <ng-container *hasPermissionAny="Layers.BDVWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_BrokenDownVehicle) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          }
          @if (isTLLayerVisible) {
            <ng-container *hasPermissionAny="Layers.TLWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_TractionLoss) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          }
          @if (isCSLayerVisible) {
            <ng-container *hasPermissionAny="Layers.CSWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_ConstructionSite) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          }
          @if (isPRLayerVisible) {
            <ng-container *hasPermissionAny="Layers.PRWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_PoorRoad) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          }
          @if (isWWDLayerVisible) {
            <ng-container *hasPermissionAny="Layers.WWDWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_WrongWayDriver) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          }
          @if (isIORLayerVisible) {
            <ng-container *hasPermissionAny="Layers.IORWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_ItemOnRoad) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          }
          @if (isALLayerVisible) {
            <ng-container *hasPermissionAny="Layers.ALWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_AmberLightVehicle) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          }
          @if (isBLLayerVisible) {
            <ng-container *hasPermissionAny="Layers.BLWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_BlueLightVehicle) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          }
          @if (isSVLayerVisible) {
            <ng-container *hasPermissionAny="Layers.SVWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_StoppedVehicle) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          }
          @if (isTJTLayerVisible) {
            <ng-container *hasPermissionAny="Layers.TJTWarning.permissions">
              <app-button-icon
                *ngVar="getMetricFromMap(metrics.Warnings_TrafficJamTail) as metric"
                [description]="metric.displayName"
                [isSelected]="selectedWarningTypeMetric === metric.key"
                [key]="metric.key"
                [icon]="metric.icon"
                (clicked)="setMetric($event)"
                data-cy="warning-type-select"
              ></app-button-icon>
            </ng-container>
          }
        </div>
        <div class="section-title col-12 text-start mt-2">Select direction:</div>
        <div class="d-flex justify-content-start gap-3 mt-2">
          <app-button-icon
            description="{{ directions.Along }}"
            [isSelected]="isDirectionAlong"
            key="{{ directions.Along }}"
            icon="rb-ic rb-ic-arrow-right-frame fs-2xl"
            (clicked)="toggleDirection(directions.Along)"
          >
          </app-button-icon>
          <app-button-icon
            description="{{ directions.Against }}"
            [isSelected]="isDirectionAgainst"
            key="{{ directions.Against }}"
            icon="rb-ic rb-ic-arrow-left-frame fs-2xl"
            (clicked)="toggleDirection(directions.Against)"
          ></app-button-icon>
        </div>
        <div class="duration-title col-12 text-start mt-2">Duration (min):</div>
        <div class="input-group col-12 mt-2 p-1">
          <input
            type="number"
            class="duration-input form-control border-0 shadow-none"
            min="4"
            max="3600"
            [defaultValue]="15"
            [(ngModel)]="duration"
            data-cy="duration-input"
          />
        </div>
        <div class="target-title col-12 text-start mt-2">Target:</div>
        <div class="target-selection d-flex flex-column gap-2 mt-2" isDemoEnabled>
          <div
            class="d-flex align-items-center gap-2"
            data-cy="target-checkboxes"
            *ngFor="let target of allowedTargets"
          >
            <input
              data-cy="target-checkbox"
              class="form-check-input mt-0"
              type="checkbox"
              [checked]="target.selected"
              (change)="this.validateScopes(target)"
            />
            <label class="target-label form-check-label mb-0 lh-1">{{ target.name }}</label>
          </div>
        </div>

        <!-- Extended Settings - Only visible with special permission -->
        <app-advanced-settings
          [(confidence)]="confidence"
          [(dfrs)]="dfrs"
          [(isExpanded)]="isAdvancedSettingsExpanded"
          [requiredPermissions]="[Permissions.RCS_Apps_All]"
        >
        </app-advanced-settings>

        <div class="col-12 p-1">
          <button
            class="btn btn-hover text-lightgray miw-100 mt-2 position-relative"
            (click)="createWarning()"
            [disabled]="disableButton || isLoading"
            data-cy="create-warning-button"
          >
            <span [class.invisible]="isLoading">Create warning</span>
            <div class="position-absolute translate-middle start-50 top-50">
              <div
                class="spinner-border text-lightgray spinner-border-sm"
                [class.d-none]="!isLoading"
                role="status"
              ></div>
            </div>
          </button>
        </div>
      </div>
    </div>
    <div
      cdkDragHandle
      class="rb-ic rb-ic-drag-handle text-gray fs-2xl z-3 position-absolute bottom-2 end-2 cursor-pointer hover-effect"
    ></div>
  </app-details>
</div>
